import React from 'react';
import { BackTop } from 'antd';
// import { CaretUpOutlined } from '@ant-design/icons';

const BackToTop: React.FC = () => {
  return (
    <BackTop>
      <div></div>
    </BackTop>
  );
};

export default BackToTop;
